import qs from "query-string";

export const getQueryStringValue = (
  key: string,
  queryString = window.location.search
): string => {
  const values = qs.parse(queryString);
  var value = values[key] as string;
  return value;
};
